import { StateCreator } from 'zustand'

import { RootState, SignUpState } from './types'

const initialState = {
  currentStep: 0,
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  displayName: '',
  timezone: '',
  eulaAccepted: false,
  isDirectBrowserFlow: false,
}

export const signUpStore: StateCreator<RootState, [], [], SignUpState> = (set) => ({
  ...initialState,
  increaseStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  decreaseStep: () => set((state) => ({ currentStep: state.currentStep - 1 })),
  skipStep: (steps: number) => set((state) => ({ currentStep: state.currentStep + steps })),
  setEmail: (email: string) => set({ email }),
  setPassword: (password: string) => set({ password }),
  setFirstName: (firstName: string) => set({ firstName }),
  setLastName: (lastName: string) => set({ lastName }),
  setDisplayName: (displayName: string) => set({ displayName }),
  setTimezone: (timezone: string) => set({ timezone }),
  setEulaAccepted: (eulaAccepted: boolean) => set({ eulaAccepted }),
  setIsDirectBrowserFlow: (isDirectBrowserFlow: boolean) => set({ isDirectBrowserFlow }),
  clearAll: () => set({ ...initialState }),
})
